<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center justify-space-between justify-md-start">
      <h3>Orari sedute della settimana</h3>
      <v-btn color="primary" append-icon="mdi-plus" class="ml-3" @click="openDialog()">Aggiungi seduta</v-btn>
    </v-col>
    <v-col cols="12" >
      <v-table density="compact" striped="even" class="border rounded">
        <thead v-if="$vuetify.display.mdAndUp">
        <tr class="bg-primary">
          <td style="width: 120px" class="font-weight-bold">Giorno</td>
          <td class="font-weight-bold">Orari sedute</td>
        </tr>
        </thead>
        <div class="w-100 " style="height: 8px" v-if="$vuetify.display.mdAndUp"></div>
        <tbody >
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Lunedì</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(1)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp">
            <h3>Lunedì</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(1)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in lunHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!lunHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Martedì</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(2)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp">
            <h3>Martedì</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(2)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in marHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!marHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Mercoledì</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(3)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp"><h3>Mercoledì</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(3)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in merHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!merHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Giovedì</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(4)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp">
            <h3>Giovedì</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(4)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in gioHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!gioHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Venerdì</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(5)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp">
            <h3>Venerdì</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(5)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in venHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!venHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Sabato</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(6)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp">
            <h3>Sabato</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(6)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in sabHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!sabHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        <tr v-if="$vuetify.display.smAndDown">
          <td class="bg-primary">
            <div class="w-100 d-flex justify-space-between align-center">
              <h3>Domenica</h3>
              <v-btn size="small" icon="mdi-plus" color="white" variant="text" @click="openDialog(0)"></v-btn>
            </div>
          </td>
        </tr>
        <tr>
          <td class="font-weight-bold py-3" v-if="$vuetify.display.mdAndUp">
            <h3>Domenica</h3>
            <v-btn icon="mdi-plus" color="primary" size="small" @click="openDialog(0)"></v-btn>
          </td>
          <td>
            <div class="d-flex flex-wrap pt-3 pb-1">
              <calendar-hour-cell v-for="hour in domHours" :key="hour._id" :hour="hour" @remove="removeHour($event)" @edit="openDialog(undefined, $event)"> </calendar-hour-cell>
              <p class="font-italic mb-2" v-if="!domHours.length">Non sono presenti sedute per questo giorno della settimana</p>
            </div>
          </td>
        </tr>
        </tbody>
      </v-table>
    </v-col>
  </v-row>

  <v-dialog v-model="addDialog" max-width="900">
    <v-card>
      <v-form ref="form" @submit.prevent="saveSeats()">
        <v-card-title>
          Inserisci seduta settimanale
        </v-card-title>
        <v-card-text v-if="editingHour">
          <v-row>
            <v-col cols="12" v-if="seatsType === SeatsType.corsi">
              <v-text-field v-model="editingHour.name" label="Nome corso" :rules="[rules.required]" />
            </v-col>
            <v-col cols="12" lg="6">
              <v-select label="Giorno della settimana" v-model="editingHour.day" :items="days" :rules="[rules.required]"></v-select>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field type="time" label="Orario" v-model="editingHour.time" :rules="[rules.required]" />
            </v-col>
            <v-col cols="12" lg="6">
              <v-select label="Durata seduta" v-model="editingHour.duration" :items="durations" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field type="number" label="N° posti per quest'ora" step="1" v-model="editingHour.max_seats"
                            :hint="`0 = valore di default inserito in impostazioni (${bookingPerHourDefault} posti)`" persistent-hint/>
            </v-col>
            <v-col cols="12" lg="6">
              <v-checkbox label="Impedisci prenotazioni per quest'ora" v-model="editingHour.restricted" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="addDialog=false;">Annulla</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" color="primary" variant="elevated" >Salva</v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-dialog>
  <v-dialog v-model="settingsDialog" max-width="900" scrollable>
    <v-card>
      <v-form ref="settingsForm" @submit.prevent="saveSeats()">
        <v-card-title v-if="editingHour" class="d-flex align-center">
          <h4>Impostazioni della seduta di {{getDayName(editingHour.day)}} alle {{editingHour.time}}</h4>
          <v-spacer></v-spacer>
          <v-btn type="submit" color="primary" variant="elevated" >Salva</v-btn>
        </v-card-title>
        <v-card-text v-if="editingHour">
          <v-row class="mt-3">
            <v-col cols="12" v-if="seatsType === SeatsType.corsi">
              <v-text-field v-model="editingHour.name" label="Nome corso" hide-details :rules="[rules.required]"/>
            </v-col>
            <v-col cols="12" lg="6">
              <v-select label="Durata seduta" v-model="editingHour.duration" :items="durations"  :rules="[rules.required]"/>
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field type="number" label="N° posti per quest'ora" step="1" v-model="editingHour.max_seats"
                            :hint="`0 = valore di default inserito in impostazioni (${bookingPerHourDefault} posti)`" persistent-hint/>
            </v-col>
            <v-col cols="12" lg="6">
              <v-checkbox label="Impedisci prenotazioni per quest'ora" v-model="editingHour.restricted" />
            </v-col>
            <v-col cols="12">
              <div class="d-flex align-center mb-3">
                <h3 class="mr-3">Impedisci la prenotazione per questi utenti</h3>
              </div>

              <p v-if="!editingHour.exclude_users || !editingHour.exclude_users.length" class="font-italic">Non cisono utenti esclusi dalla prenotazione di quest'ora</p>
              <div class="d-flex flex-wrap w-100 justify-space-between">
                <div class="rounded border pa-3 mr-2 mb-2 d-flex align-center flex-grow-1 justify-space-between"  v-for="id in editingHour.exclude_users" :key="id" >
                  <div class="pr-3">
                    <h4>{{getUserName(id)}}</h4>
                    <p class="text-caption text-grey-darken-3">{{getUserFiscalCode(id)}}</p>
                  </div>
                  <v-btn icon="mdi-close" color="error" variant="text" @click="removeUser(id)"></v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex">
              <v-autocomplete label="Utente" :items="userOptions" v-model="excludeUser" class="mr-2 flex-grow-1 flex-shrink-1" >


                <template v-slot:selection="{item}">
                  <div>
                    <h4 class="mb-0" style="line-height: 1.1" >{{item.title}}</h4>
                    <p class="text-caption text-grey-darken-3" style="line-height: 1">{{item.raw.fiscal_code}}</p>
                  </div>


                </template>

                <template v-slot:item="{props, item}">
                  <v-list-item v-bind="props" :subtitle="item.raw.fiscal_code"></v-list-item>
                </template>
              </v-autocomplete>
              <v-btn append-icon="mdi-plus" color="primary" class="flex-grow-0 flex-shrink-0" :disabled="!excludeUser" @click="addUserToExcluded()">Aggiungi</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="settingsDialog=false;">Annulla</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" color="primary" variant="elevated" >Salva</v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import {computed, defineComponent, inject, type PropType, ref, useTemplateRef} from 'vue'
import {type CalendarHour, SeatsType} from "@/models.ts";
import CalendarHourCell from "@/components/CalendarHourCell.vue";
import {type Messages, Msg} from "@/plugins/messages.ts";
import api from "@/api";
import {VForm} from "vuetify/components";
import rules from "@/utils/rules.ts";
import type {Globals} from "@/plugins/globals.ts";
import utils from "@/utils";

export default defineComponent({
  name: "SeatsCalendar",
  components: {CalendarHourCell},
  props : {
    calendarHours : {
      type : Array as PropType<CalendarHour[]>,
      default : []
    },
    seatsType : {
      type : String as PropType<SeatsType>,
      required: true,
      default : SeatsType.exp,
    }
  },
  emits : ['refresh'],
  setup(props, ctx) {

    const globals = inject('globals') as Globals
    const messages = inject('messages') as Messages

    const addDialog = ref(false)
    const settingsDialog = ref(false)
    const editingHour = ref<CalendarHour|undefined>()
    const excludeUser = ref<string|undefined>()
    const form = useTemplateRef<typeof VForm>('form')
    const settingsForm = useTemplateRef<typeof VForm>('settingsForm')

    const lunHours = computed(()=>props.calendarHours.filter(i => i.day === 1))
    const marHours = computed(()=>props.calendarHours.filter(i => i.day === 2))
    const merHours = computed(()=>props.calendarHours.filter(i => i.day === 3))
    const gioHours = computed(()=>props.calendarHours.filter(i => i.day === 4))
    const venHours = computed(()=>props.calendarHours.filter(i => i.day === 5))
    const sabHours = computed(()=>props.calendarHours.filter(i => i.day === 6))
    const domHours = computed(()=>props.calendarHours.filter(i => i.day === 0))

    const getDayName = (day:number) => {
      switch (day) {
        case 1:
          return "Lunedì"
        case 2:
          return "Martedì"
        case 3:
          return "Mercoledì"
        case 4:
          return "Giovedì"
        case 5:
          return "Venerdì"
        case 6:
          return "Sabato"
      }
      return "Domenica"
    }

    return {
      SeatsType,
      addDialog,
      settingsDialog,
      form,
      settingsForm,
      rules,
      editingHour,
      excludeUser,
      bookingPerHourDefault : computed(()=>{
        switch (props.seatsType) {
          case SeatsType.exp:
            return globals.settings.value.bookings_per_hour_exp;
          case SeatsType.corsi:
            return globals.settings.value.bookings_per_hour_corsi;
          case SeatsType.gym:
            return globals.settings.value.bookings_per_hour_gym;
          case SeatsType.vacu:
            return globals.settings.value.bookings_per_hour_vacu;
          case SeatsType.opengym:
            return globals.settings.value.bookings_per_hour_macchine;
        }
      }),
      settings : globals.settings,
      days : [
        { title : 'Lunedì', value : 1},
        { title : 'Martedì', value : 2},
        { title : 'Mercoledì', value : 3},
        { title : 'Giovedì', value : 4},
        { title : 'Venerdì', value : 5},
        { title : 'Sabato', value : 6},
        { title : 'Domenica', value : 0},
      ],
      durations: [
        { title : "30 minuti", value : 30},
        { title : "45 minuti", value : 45},
        { title : "1 ora", value : 60},
        { title : "1 ora e 15 minuti", value : 75},
        { title : "1 ora e 30 minuti", value : 90},
        { title : "1 ora e 45minuti", value : 105},
        { title : "2 ore", value : 120},
      ],
      getDayName,
      lunHours,
      marHours,
      merHours,
      gioHours,
      venHours,
      sabHours,
      domHours,
      maxHours: computed(()=>Math.max(lunHours.value.length, marHours.value.length, merHours.value.length, gioHours.value.length, venHours.value.length, sabHours.value.length, domHours.value.length)),
      removeHour(hour:CalendarHour) {
        messages.requestConfirm("Richiesta conferma",
            `Sei sicuro di voler eliminare l'orario delle ${hour.time} dalle sedute del${hour.day === 0 ? 'la domenica' : ` ${getDayName(hour.day)}`}`, false, async ok => {
              if(!ok) return;
              const res = await api.del("hours", hour._id!);
              if(!res.success) {
                messages.error(res.message ?? Msg.serverError)
                return;
              }
              messages.success("Seduta eliminata");
              ctx.emit('refresh')
            })
      },
      openDialog(day?:number, hour?:CalendarHour) {
        editingHour.value = hour ?? {
          day: day ?? 1,
          duration: 60,
          exclude_users: [],
          max_seats: 0,
          name: "",
          restricted: false,
          time: "",
          type: props.seatsType
        }
        if(editingHour.value._id) {
          settingsDialog.value = true
        } else {
          addDialog.value = true
        }
      },
      getUserName(id:string) {
        const user = globals.users.value.find(i => i._id === id)
        return user ? `${user.name} ${user.surname}` : id
      },
      getUserFiscalCode(id:string) {
        const user = globals.users.value.find(i => i._id === id)
        return user ? user.fiscal_code : ''
      },
      userOptions : computed(()=> {
        return globals.users.value.filter(i => {
          if(!editingHour.value || !editingHour.value.exclude_users) return true
          return !editingHour.value.exclude_users.includes(i._id!)
        }).map(i => {
          return { title : `${i.name} ${i.surname}`, fiscal_code : i.fiscal_code, value : i._id}
        })
      }),
      removeUser(id:string) {
        const user = globals.users.value.find(i => i._id === id)
        messages.requestConfirm("Richiesta conferma", `Vuoi davvero eliminare ${user ? `${user.name} ${user.surname}` : 'questo utente'} dalla lista degli esclusi di questo orario?`,false, ok =>{
          if(!ok) return;
          editingHour.value!.exclude_users = editingHour.value!.exclude_users.filter(i => i !== id)
        })
      },
      addUserToExcluded() {
        if(!excludeUser.value) return
        if(!editingHour.value!.exclude_users) editingHour.value!.exclude_users = [];
        editingHour.value!.exclude_users.push(excludeUser.value)
        excludeUser.value = undefined
      },
      async saveSeats() {
        if(editingHour.value?._id) {
          const { valid } = await settingsForm.value!.validate()
          if(!valid) return
        } else {
          const { valid } = await form.value!.validate()
          if(!valid) return
        }

        editingHour.value!.max_seats = utils.toInt(editingHour.value!.max_seats, 0)

        const res = await api.save("hours", editingHour.value!)
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          return
        }
        messages.success("Orario seduta salvato!")
        addDialog.value = false
        settingsDialog.value = false
        editingHour.value = undefined
      }
    }
  }
})
</script>



<style scoped>

</style>